import type { SVGProps } from "react";
const SvgIconCreditcard = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="M128 718a50 50 0 0 0 50 50h668a50 50 0 0 0 50-50V448H128Zm64-196a10 10 0 0 1 10-10h132a10 10 0 0 1 10 10v80a10 10 0 0 1-10 10H202a10 10 0 0 1-10-10ZM846 256H178a50 50 0 0 0-50 50v46h768v-46a50 50 0 0 0-50-50" />
  </svg>
);
export default SvgIconCreditcard;
